import type { Note } from './types';

const BASE = import.meta.env.VITE_API_URL || '';
const csrf = () => document.cookie.match(/(?:^|; )csrf_token=([^;]+)/)?.[1] || '';
type User={id:string;name:string;email:string;role:string};

async function request<T>(path:string, init:RequestInit = {}):Promise<T> {
  const res = await fetch(`${BASE}/api${path}`, { ...init, credentials:'include', headers:{ 'Content-Type':'application/json', 'X-CSRF-Token':csrf(), ...init.headers } });
  if (!res.ok) throw new Error((await res.json().catch(()=>({}))).error || 'Request failed');
  return res.json();
}
export const api = {
  login:(email:string,password:string,remember=true)=>request<{user:User}>('/auth/login',{method:'POST',body:JSON.stringify({email,password,remember})}),
  register:(name:string,email:string,password:string)=>request<{ok:true}>('/auth/register',{method:'POST',body:JSON.stringify({name,email,password})}),
  me:()=>request<{user:User}>('/auth/me'),
  logout:()=>request('/auth/logout',{method:'POST'}),
  notes:()=>request<{notes:Note[]}>('/notes'),
  save:(note:Partial<Note>&{id:string})=>request<{note:Note}>(`/notes/${note.id}`,{method:'PUT',body:JSON.stringify(note)}),
  create:()=>request<{note:Note}>('/notes',{method:'POST',body:JSON.stringify({title:'Untitled note',content:''})}),
};
